<template>
	<transition-group
			v-if="$store.state.species.speciesList"
			name="list"
			tag="div"
			id="gallery-container"
			class="row justify-start q-col-gutter-sm"
	>
		<SpeciesTeaser
				v-for="woodSpecies in filteredSpeciesList"
				:key="woodSpecies.uid"
				:species="woodSpecies"
				class="col-6 col-sm-4 col-md-2 species-teaser"
		/>
	</transition-group>
</template>

<script>
	import {mapGetters} from "vuex";
	import SpeciesTeaser from "@/components/gallery/SpeciesTeaser";

	export default {
		name: "GalleryTeaserList",
		components: {SpeciesTeaser},
		computed: {
			...mapGetters(['filteredSpeciesList'])
		}
	}
</script>

<style lang="scss" scoped>
	.list-enter-active {
		transition: all 0.5s;
	}

	.list-leave-active {
		position: absolute;
	}

	.list-enter,
	.list-leave-to {
		opacity: 0;
		transform: translateY(30px);
	}

	.list-move {
		transition: transform 0.3s;
	}
</style>